import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";

import FindBranchPop from "./FindBranchPop";
import { NoNearestIcon } from "../Styles/Icons";

const NoNearestPop = ({ nearestPop, setNearestPop }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openFindBranch, setOpenFindBranch] = useState(false);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={nearestPop}
      fullWidth={true}
      maxWidth={"sm"}
      aria-labelledby="draggable-dialog-title"
    >
      <Grid sx={{ py: 2, px: 3 }}>
        <DialogContent sx={{ px: { sm: 5, xs: 0 } }}>
          <Grid
            sx={{ alignItems: "center", justifyContent: "center", gap: 3 }}
            container
          >
            <NoNearestIcon />
            <Typography sx={{ textAlign: "center" }}>
              No Nearest Branch found for your location. Choose your branch
              manually to get the service details.
            </Typography>
            <Grid
              sx={{
                justifyContent: "center",
                alignItems: "center",
                mt: 3,
              }}
              container
            >
              <Button
                onClick={() => setOpenFindBranch(true)}
                sx={{
                  textTransform: "capitalize",
                  background: "#CCD0FF",
                  color: "#000",
                  width: "50%",
                }}
                variant="contained"
                size="small"
              >
                Choose Branch
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Grid>

      {openFindBranch && (
        <FindBranchPop
          openFindBranch={openFindBranch}
          setOpenFindBranch={setOpenFindBranch}
          setNearestPop={setNearestPop}
        />
      )}
    </Dialog>
  );
};

export default NoNearestPop;
